import { proxy } from "valtio";
import { MapFrame } from "../types/map";

export const inGameState = proxy<{ frame: MapFrame; connected: boolean }>({
	frame: { frameIndex: 0 },
	connected: false,
});